import { render } from "./Card.vue?vue&type=template&id=3f10d722&scoped=true&ts=true"
import script from "./Card.vue?vue&type=script&lang=ts"
export * from "./Card.vue?vue&type=script&lang=ts"

import "./Card.vue?vue&type=style&index=0&id=3f10d722&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f10d722"]])

export default __exports__